import styled from 'styled-components';
import materialUI from '../../material-UI';

export const Container = styled.div`
  height: 100%;
  width: 100%;
`;
export const Img: any = styled.img`
  height: 16px;
`;
export const List = styled.div`
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const Nav = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 82%;
  background-color: white;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 25px;
  padding-bottom: 16px;
`;
// @ts-ignore
export const SwipeableDrawer = styled(materialUI.SwipeableDrawer)`
  display: flex;
  position: absolute;
  width: 284px;
  border: none;
  border-top-right-radius: 20;
  background-color: transparent;
  box-shadow: none;

`;
export const Collapse = styled(materialUI.Collapse)``;
